import { memo } from 'react';

import { useScopedTranslate } from '@locale/translate';

import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'convert_document';

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Convert document',
  },
};
